<style scoped lang="scss">
@import '~variables';

.files {
    display: flex;
    flex-wrap: wrap;

    .card {
        width: 150px;

        &.not-dragable {
            .card-img-top {
                cursor: not-allowed;
            }
        }

        &.dragable {
            .card-img-top {
                cursor: move;
            }
        }

        .card-img-top-wrapper {
            position: relative;

            .card-img-top {
                height: 150px;
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center center;
            }
        }

        .card-img-overlay {

            &:hover {
                .card-img-overlay-menu, .card-img-overlay-menu-items {
                    display: flex;
                }
            }

            .card-img-overlay-menu {
                display: none;
                justify-content: space-between;
            }

            .card-img-overlay-menu-items {
                display: none;
                flex-direction: column;
            }

        }

        .file-desc {
            font-size: .825rem;
        }
    }

}
</style>
<template>
    <div class="row">
        <div class="col-12 col-md-8">


            <button v-if="selectedItems.length > 0" type="button" @click="move(selectedItems)" class="btn btn-sm btn-info m-1">
                <span class="fas fa-arrows-alt ml-1"></span>
                {{ trans.get('general.move') }}
            </button>
            <button v-if="selectedItems.length > 0" type="button" @click="move(selectedItems, true)" class="btn btn-sm btn-info m-1">
                <span class="fas fa-copy ml-1"></span>
                {{ trans.get('general.copy') }}
            </button>

            <draggable class="files" :disabled="isUploading" v-model="files" @start="drag=true" @end="drag=false" @change="orderChanged">

                <div class="card m-2" :class="{'not-dragable': isUploading, 'dragable': !isUploading}" v-for="file in files" :key="file.id">
                    <div class="card-img-top-wrapper">
                        <div class="card-img-top" :style="{'background-image': 'url(\'' + getThumbnail(file) + '\')', 'transform': file.rotation ? `rotate(${file.rotation}deg)` : ''}">
                        </div>

                        <div class="card-img-overlay p-0">
                            <div class="card-img-overlay-menu">
                                <button type="button" @click="Vue.set(file, 'showMenu', !file.showMenu)" class="btn btn-sm btn-info m-1" :disabled="isUploading" :class="{disabled: isUploading}">
                                    <span class="fas fa-cogs"></span>
                                </button>
                                <button v-if="!file.showMenu" type="button" @click="removeFile(file)" class="btn btn-sm btn-danger m-1" :disabled="isUploading" :class="{disabled: isUploading}">
                                    <span class="fas fa-trash mr-1"></span>
                                </button>
                            </div>

                            <div class="card-img-overlay-menu-items" v-if="file.showMenu">
                                <button type="button" @click="editFile(file)" class="btn btn-sm btn-info m-1">
                                    <span class="fas fa-edit ml-1"></span>
                                    {{ trans.get('general.edit') }}
                                </button>
                                <button v-if="!file.showRotation" type="button" @click="Vue.set(file, 'showRotation', !file.showRotation)" class="btn btn-sm btn-info m-1" :disabled="isUploading" :class="{disabled: isUploading}">
                                    <span class="fas fa-tools ml-1"></span>
                                    {{ trans.get('general.rotate') }}
                                </button>
                                <div v-if="file.showRotation">
                                    <button type="button" @click="rotate(file, '-90');" class="btn btn-sm btn-info m-1" :disabled="isUploading" :class="{disabled: isUploading}">
                                        <span class="fas fa-undo"></span>
                                    </button>
                                    <button type="button" @click="rotate(file, '180');" class="btn btn-sm btn-info m-1" :disabled="isUploading" :class="{disabled: isUploading}">
                                        <span class="fas fa-retweet"></span>
                                    </button>
                                    <button type="button" @click="rotate(file, '90');" class="btn btn-sm btn-info m-1" :disabled="isUploading" :class="{disabled: isUploading}">
                                        <span class="fas fa-redo"></span>
                                    </button>
                                </div>

                                <button type="button" @click="move([file.id])" class="btn btn-sm btn-info m-1">
                                    <span class="fas fa-arrows-alt ml-1"></span>
                                    {{ trans.get('general.move') }}
                                </button>

                                <button type="button" @click="move([file.id], true)" class="btn btn-sm btn-info m-1">
                                    <span class="fas fa-copy ml-1"></span>
                                    {{ trans.get('general.copy') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card-body p-1">
                        <div>
                            <input type="checkbox" name="check" :value="file.id" v-model="selectedItems">
                            <strong>{{ file.name }}</strong>
                        </div>
                        <div class="file-desc">{{ file.description }}</div>
                    </div>
                </div>

            </draggable>

        </div>
        <div class="col-12 col-md-4">
            <label for="upload">{{ trans.get('collections.files') }}</label>
            <upload
            id="upload"
            url="/dynamic/upload"
            :thumbHeight="150"
            :thumbWidth="150"
            @file-success="fileSuccess"
            @file-error="fileError"
            @file-rejected="fileRejected"
            @upload-started="uploadStarted"
            @upload-completed="uploadCompleted"
            :extensionWhitelist="extensionWhitelist"
            ></upload>
        </div>

        <modal @initized="modal = $event">

            <!-- <div class="form-group">
                <label >{{ trans.get('file-manager.type') }}</label>
                <div class="form-radio">
                    <input class="form-radio-input" type="radio" name="type" v-model="moveModel.type" value="collection" id="collections">
                    <label class="form-radio-label" for="collections">
                        {{ trans.get('collections.title') }}
                    </label>
                </div>
                <div class="form-radio">
                    <input class="form-radio-input" type="radio" name="type" v-model="moveModel.type" value="post" id="posts">
                    <label class="form-radio-label" for="posts">
                        {{ trans.get('posts.title') }}
                    </label>
                </div>
                <div class="invalid-feedback" v-has-error="'type'">
                    {{ trans.get('validation.required', {'attribute': trans.get('file-manager.type').toLowerCase() }) }}
                </div>
            </div> -->

            <div v-if="moveModel.type === 'collection'">

                <datatable-search :search="collectionsSearch" :fields="[{fields: ['id'], type: 'OrWhere'}, 'name']"></datatable-search>


                <div class="form-radio" v-for="row in collectionsSearch.pageObject.data">
                    <input class="form-radio-input" type="radio" name="target" v-model="moveModel.target" :value="row.id" :id="'col_item_' + row.id">
                    <label class="form-radio-label" :for="'col_item_' + row.id">
                        {{ row.name }}
                    </label>
                </div>
                <div class="invalid-feedback" v-has-error="'target'">
                    {{ trans.get('validation.required', {'attribute': trans.get('file-manager.target').toLowerCase() }) }}
                </div>

            </div>
            <div v-if="moveModel.type === 'post'">
                <div class="form-group">
                    <label >{{ trans.get('file-manager.post-target') }}</label>
                    <div class="form-radio" v-if="selectedItems.length === 1">
                        <input class="form-radio-input" type="radio" name="attribute" v-model="moveModel.attribute" value="cover" id="cover">
                        <label class="form-radio-label" for="cover">
                            {{ trans.get('posts.cover') }}
                        </label>
                    </div>
                    <div class="form-radio">
                        <input class="form-radio-input" type="radio" name="attribute" v-model="moveModel.attribute" value="images" id="posts">
                        <label class="form-radio-label" for="posts">
                            {{ trans.get('posts.images') }}
                        </label>
                    </div>
                    <div class="form-radio">
                        <input class="form-radio-input" type="radio" name="attribute" v-model="moveModel.attribute" value="files" id="files">
                        <label class="form-radio-label" for="files">
                            {{ trans.get('posts.attachments') }}
                        </label>
                    </div>
                    <div class="invalid-feedback" v-has-error="'attribute'">
                        {{ trans.get('validation.required', {'attribute': trans.get('file-manager.post-target').toLowerCase() }) }}
                    </div>
                </div>

                <datatable-search :search="postsSearch" :fields="[{fields: ['id'], type: 'OrWhere'}, 'name']"></datatable-search>

                <div class="form-radio" v-for="row in postsSearch.pageObject.data">
                    <input class="form-radio-input" type="radio" name="postTarget" v-model="moveModel.target" :value="row.id" :id="'post_item_' + row.id">
                    <label class="form-radio-label" :for="'post_item_' + row.id">
                        {{ row.name }}
                    </label>
                </div>

                <div class="invalid-feedback" v-has-error="'target'">
                    {{ trans.get('validation.required', {'attribute': trans.get('file-manager.target').toLowerCase() }) }}
                </div>
            </div>

            <spinner class="spinner" v-if="collectionsSearch.isLoading || postsSearch.isLoading" :initStart="true" :inline="true"></spinner>

            <template v-slot:footer="slotProps">
                <button type="button" class="btn btn-info" @click="slotProps.close(false)" :disabled="isStoring">{{ trans.get('general.cancel') }}</button>
                <button type="button" class="btn btn-success" @click="applyMove(slotProps)" :disabled="isStoring">{{ trans.get('general.' + (moveModel.copy ? 'copy' : 'move')) }}</button>
            </template>
        </modal>

        <modal @initized="editFileModal = $event">
            <div class="form-group">
                <a :href="'/download/' + $v.editFileModel.hash.$model" target="_blanc" class="btn btn-sm btn-info m-1">
                    <span class="fas fa-download ml-1"></span>
                    {{ trans.get('general.download') }}
                </a>
            </div>

            <div class="form-group">
                <label for="name">{{ trans.get('file-manager.name') }}</label>
                <input type="text" class="form-control" id="name" v-model.trim="$v.editFileModel.name.$model">
                <div class="invalid-feedback" v-has-error="'name'">
                    {{ trans.get('validation.required', {'attribute': trans.get('file-manager.name').toLowerCase() }) }}
                </div>
            </div>

            <div class="form-group">
                <label for="description">{{ trans.get('file-manager.description') }}</label>
                <textarea class="form-control" id="description" v-model.trim="$v.editFileModel.description.$model"></textarea>
            </div>

            <div class="form-group">
                <label for="tags">{{ trans.get('file-manager.tags') }}</label>
                <input type="text" class="form-control" id="tags" v-model.trim="$v.editFileModel.tags.$model">
            </div>

            <div class="form-group">
                <label for="url">{{ trans.get('file-manager.url') }}</label>
                <input type="text" class="form-control" id="url" v-model.trim="$v.editFileModel.url.$model">
            </div>

            <spinner class="spinner" v-if="collectionsSearch.isLoading || postsSearch.isLoading" :initStart="true" :inline="true"></spinner>

            <template v-slot:footer="slotProps">
                <button type="button" class="btn btn-info" @click="slotProps.close(false)" :disabled="isStoring">{{ trans.get('general.cancel') }}</button>
                <button type="button" class="btn btn-success" @click="applyEditFile(slotProps)" :disabled="isStoring">{{ trans.get('general.save') }}</button>
            </template>
        </modal>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { VueSearch } from '@admin/shared/datatable/search';
    import { required, requiredIf } from 'vuelidate/lib/validators';

    export default {

        components: {
            draggable,
        },

        props: {
            value: Array,
            isUploading: Boolean,
            id: Number,
            extensionWhitelist: {
                type: Array,
                default: () => ['jpg', 'png', 'jpeg', 'gif', 'svg'],
            },
        },

        data() {
            return {
                modal: undefined,
                editFileModal: undefined,
                files: [],
                selectedItems: [],
                collectionsSearch: new VueSearch({
                    url: '/dynamic/collections',
                    name: 'moveCollections',
                    autoInit: false,
                    perPage: 10,
                    withoutStorage: true,
                    onStart: () => {
                        Vue.set(this.moveModel, 'target', null);
                    },
                    onSuccess: () => {
                        Vue.set(this.moveModel, 'target', null);
                    }
                }),
                postsSearch: new VueSearch({
                    url: '/dynamic/posts',
                    name: 'movePosts',
                    autoInit: false,
                    perPage: 10,
                    withoutStorage: true,
                    onStart: () => {
                        Vue.set(this.moveModel, 'target', null);
                    },
                    onSuccess: () => {
                        Vue.set(this.moveModel, 'target', null);
                    }
                }),
                moveModel: {
                    copy: false,
                    type: 'collection',
                    attribute: null,
                    target: null,
                },
                editFileModel: {
                    hash: '',
                    name: '',
                    description: '',
                    tags: '',
                    url: '',
                },
                isSubmitted: false,
                isStoring: false,
                Vue: Vue,
            };
        },

        validations: {
            moveModel: {
                type: {
                    required,
                },
                attribute: {
                    required: requiredIf((model) => {
                        return model.type === 'post';
                    })
                },
                target: {
                    required
                },
            },
            editFileModel: {
                hash: {
                    required,
                },
                name: {
                    required,
                },
                description: {
                },
                tags: {
                },
                url: {
                },
            }
        },

        created() {
            this.files = JSON.parse(JSON.stringify(this.value));
        },

        methods: {

            getThumbnail(file) {
                if (file.thumbs && file.thumbs.x400) {
                    return file.thumbs.x400
                } else if (file.thumb) {
                    return file.thumb;
                } else {
                    return 'https://cdn.jsdelivr.net/npm/pretty-file-icons@2.2.1/svg/' + prettyFileIcons.getIcon(file.name, 'svg')
                }
            },

            fileSuccess(event) {
                this.files.push(JSON.parse(JSON.stringify(Object.assign({}, event.data, event.file))));
                this.$emit('input', this.files);
                this.$nextTick(() => {
                    this.orderChanged();
                });
            },

            fileError(event) {
                this.$toasted.global.appError({
                    message : this.trans.get('general.upload_error') + event.error
                });
            },

            fileRejected(event) {
                this.$toasted.global.appError({
                    message : this.trans.get('general.upload_file_rejected', {file: event.file.name})
                });
            },

            uploadStarted() {
                this.$emit('update:isUploading', true);
            },

            uploadCompleted() {
                this.$emit('update:isUploading', false);
                this.$nextTick(() => {
                    this.orderChanged();
                });
            },

            rotate(file, degrees) {
                Vue.set(file, 'rotation', (file.rotation || 0) + parseInt(degrees, 10));
                Vue.set(file, 'showMenu', false);
                Vue.set(file, 'showRotation', false);

                axios.put(`/dynamic/collections/${this.id}/rotate-file/${file.id}/${degrees}`)
                    .catch(error => {
                        this.$toasted.global.appError({
                            message : this.trans.get('collections.file_rotation_error') + error
                        });
                    });
            },

            move(fileIds, copy = false) {
                this.moveModel = {
                    copy: copy,
                    type: 'collection',
                    attribute: null,
                    target: null,
                };
                this.selectedItems = fileIds;

                this.modal
                .title(copy ? this.trans.get('file-manager.copy-title') : this.trans.get('file-manager.move-title'))
                .show(() => {
                    this.$v.$reset();
                    this.isSubmitted = false;
                    this.collectionsSearch.pageObject.data = [];
                    this.postsSearch.pageObject.data = [];
                });

            },

            applyMove(slotProps) {
                this.isSubmitted = true;
                this.$forceUpdate();

                if (!this.$v.moveModel.$pending && !this.$v.moveModel.$invalid && !this.isStoring) {
                    this.isStoring = true;

                    this.moveModel.file_ids = this.selectedItems;

                    let promise;
                    if (this.moveModel.copy) {
                        promise = axios.put(`/dynamic/collections/${this.id}/copy`, this.moveModel);
                    } else {
                        promise = axios.put(`/dynamic/collections/${this.id}/move`, this.moveModel);
                    }

                    this.$root.pageSpinner.spin(promise)
                        .then(response => {

                            if (!this.moveModel.copy) {
                                this.files = this.files.filter(f => {
                                    return this.selectedItems.indexOf(f.id) === -1;
                                });
                                this.$emit('input', this.files);
                                this.$nextTick(() => {
                                    this.orderChanged();
                                });
                            }

                            this.$v.$reset();
                            this.isSubmitted = false;

                            this.$toasted.global.appSuccess({
                                message : this.trans.get('general.' + (this.moveModel.copy ? 'copy' : 'move') + '_success')
                            });

                            slotProps.close();
                        })
                        .catch(error => {
                            this.$toasted.global.appError({
                                message : this.trans.get('general.' + (this.moveModel.copy ? 'copy' : 'move') + '_error') + error
                            });
                        })
                        .finally(() => {
                            this.isStoring = false;
                        });
                }

            },

            editFile(file) {
                this.editFileModel = {
                    hash: file.hash,
                    name: file.name,
                    description: file.description,
                    tags: file.tags,
                    url: file.url,
                };

                this.editFileModal
                .title(this.trans.get('file-manager.edit-title'))
                .show(() => {
                    this.editFileModel = null;
                });

            },

            applyEditFile(slotProps) {
                this.isSubmitted = true;
                this.$forceUpdate();

                if (!this.$v.editFileModel.$pending && !this.$v.editFileModel.$invalid && !this.isStoring) {
                    this.isStoring = true;

                    this.$root.pageSpinner.spin(axios.put(`/dynamic/collections/${this.id}/file/${this.editFileModel.hash}`, this.editFileModel))
                        .then(response => {

                            this.files = this.files.map((item) => {
                                if (item.id === response.data.id) {
                                    item.hash = response.data.hash
                                    item.name = response.data.name
                                    item.description = response.data.description
                                    item.tags = response.data.tags
                                    item.url = response.data.url
                                }

                                return item;
                            });

                            this.$v.$reset();
                            this.isSubmitted = false;

                            this.$toasted.global.appSuccess({
                                message : this.trans.get('general.save_success')
                            });

                            slotProps.close();
                        })
                        .catch(error => {
                            this.$toasted.global.appError({
                                message : this.trans.get('general.save_error') + error
                            });
                        })
                        .finally(() => {
                            this.isStoring = false;
                        });
                }

            },

            removeFile(file){
                if (!this.isUploading) {
                    this.files = this.files.filter(f => {
                        return f != file;
                    });
                    this.$emit('input', this.files);
                    this.$nextTick(() => {
                        this.orderChanged();
                    });
                }
            },

            orderChanged(){
                if (this.id && !this.isUploading) {
                    const fileIds = this.files.map(item => item.id);
                    (axios.put('/dynamic/collections/' + this.id + '/sync-files', {file_ids: fileIds})) // TODO spinner
                    .then(response => {
                        this.$toasted.global.appSuccess({
                            message : this.trans.get('collections.file_save_success')
                        });
                    })
                    .catch(error => {
                        this.$toasted.global.appError({
                            message : this.trans.get('collections.file_save_error') + error
                        });
                    });
                    this.$emit('input', this.files);
                }
            },

        },

        watch: {
            value: function(newVal, oldVal) {
                this.files = newVal;
            }
        },

    }
</script>
